module.exports = __webpack_public_path__ + "img/bh_23.c3630cdf.jpg";